import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=9ba8097a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=9ba8097a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba8097a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ba8097a')) {
      api.createRecord('9ba8097a', component.options)
    } else {
      api.reload('9ba8097a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=9ba8097a&scoped=true&", function () {
      api.rerender('9ba8097a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f0pnJQiuDB5k/JS/teamMember.vue"
export default component.exports